module.exports = __webpack_public_path__ + "static/media/edit_location.3e1ca4fb.svg";